import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import logo from "../../../assets/img/logo.png"; // Adjust path as needed
import profileicon from "../../../assets/img/profile-icon.png"; // Adjust path as needed
import { useNavigate } from "react-router-dom";

const AdminNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear(); // Clears all stored data
    navigate("/login", { replace: true }); // Redirects to login and prevents back navigation
  };

  return (
    <Navbar
      bg="white"
      variant="light"
      className="container-fluid"
      sticky="top"
      expand="lg"
      style={{
        padding: "0px 10px",
        borderBottom: "0.5px solid lightgray",
        width: "auto",
      }}
    >
      {/* Brand Logo */}
      <Navbar.Brand href="/">
        <img
          src={logo}
          alt="Logo"
          width="70"
          height="70"
          className="d-inline-block align-top"
        />
      </Navbar.Brand>

      {/* Navbar Toggle for Mobile */}
      <Navbar.Toggle aria-controls="navbar-nav" />

      {/* Navbar Content */}
      <Navbar.Collapse id="navbar-nav" className="justify-content-end">
        <Nav>{/* Logout Button */}</Nav>
        <Button variant="danger" size="md" onClick={handleLogout}>
          Logout
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <img
          src={profileicon}
          alt="Logo"
          width="55"
          height="55"
          className="d-inline-block align-top"
        />
      </Navbar.Collapse>
    </Navbar>
  );
};

export default AdminNavbar;
